/* export const ApiHost = `https://localhost:5280`
 */
export const ApiHost = ``